<template>
  <div class="best_shop_block">
    <div class="best_shop_title">
      <a :href="params.link" class="def-bt pink">{{params.messages.allShops}}</a>
    </div>
    <div class="best_shop_items row justify-content-md-center">
      <div class="best_shop_item col-md-4" v-for="item in params.items">
        <a :href="item.link" class="best_shop_link"><img :src="item.picture" width="100%"></a>
        <a :href="item.link"  class="best_shop_name">{{item.name}}</a>
        <a :href="item.link"  class="best_shop_detail">{{params.messages.moreInfo}}></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shops_best",
  selector: '.shops_best',
  props:{params: Object},
  mounted() {
    this.$nextTick(() => {
      $('.best_shop_items').slick({
        respondTo: 'slider',
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        initialSlide: 0,
        centerPadding: '0px',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              centerMode: false,
              initialSlide: 0
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: false,
              centerMode: false,
              initialSlide: 0
            }
          }
        ]
      });
    });
  }
}
</script>

<style scoped>
  .best_shop_title {
    text-align: right;
    margin-bottom: 10px;
  }
  .best_shop_title a {
    display: inline-block;
  }
  .best_shop_link {
    display: inline-block;
  }
  .best_shop_name {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    color: #000000;
    margin-bottom: 10px;
    display: block;
  }
  .best_shop_detail {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    color: #3b3d40;
    display: inline-block;
  }
  .best_shop_item {
  margin-bottom: 20px;
  }
  @media (max-width: 768px) {
    .best_shop_item {
    text-align: center;
    }
    .best_shop_title {
      text-align: center;
    }
  }
</style>